import { OrderResponse } from "../../types";
import "./bid.scss";

type BidHeaderProps = {
  /**
   * Unused by this component (was already unused in the pre-Carbon version too — only
   * destructured as `{ setOpen, selected, orderName }`). Kept, optional, purely so the
   * out-of-scope `SellerOffer.tsx`/`JointSellerOffer.tsx` (sub-flow C, not migrated by this
   * task) — which still pass it — keep type-checking unchanged.
   */
  order?: OrderResponse;
  orderName?: string;
  /**
   * Also kept for the same out-of-scope-caller compatibility reason as `order` above. The
   * pre-Carbon mobile-only inline "cancel" icon button that read `selected`/called `setOpen`
   * (`sm:hidden`, duplicating the main toolbar's own Cancel button one tap away) is dropped
   * rather than ported here — `BidToolbar.tsx` already renders that action for every viewport,
   * so it was a redundant, breakpoint-only affordance rather than distinct behaviour. Neither
   * prop is read by this component any more.
   */
  selected?: boolean;
  setOpen?: (open: boolean) => void;
};

/**
 * The order/RFQ name heading (Task 7) — plain `<h1>` styled through `bid.scss`, replacing the
 * Tailwind `text-2xl font-bold uppercase` heading.
 */
const BidHeader = ({ orderName }: BidHeaderProps) => {
  return (
    <div className="bid-header">
      <h1 className="bid-header__title">{orderName}</h1>
    </div>
  );
};

export default BidHeader;
